import { mapMutations, mapState } from 'vuex';
import iotFetchMixin from './iotFetchMixin';
import AddressLatLongMixin from '@/components/core/addressLatLongMixin';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinDuplicateIothubOrComplete',
  mixins: [iotFetchMixin, AddressLatLongMixin],
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    twinCopiesData: {
      type: Array,
      required: true
    },
    statePickerMode: {
      type: String,
      required: true
    },
    errornousParentId: {
      type: Number,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: true
    },
    globalParentTwin: {
      type: Object,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    globalParentId: {
      // is either false or a number
      required: true
    },
    loadingStates: {
      type: Boolean,
      required: true
    },
    pickableStates: {
      type: Array,
      required: true
    },
    metaInfoToggles: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    titlePlaceholder() {
      return `${this.orgTwin.title} copy [X]`;
    },
    tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [5, 10, 20]
      };
    }
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    get,
    stateConfigChanged(index, stateIndex, prefix) {
      this.$refs[`${prefix}_${index}_state_${stateIndex}`][0].saveState();
    },
    twinParentFilter(twin) {
      return !get(twin, 'properties.disabled');
    },
    updateTwinsParents(parentTwin) {
      this.twinCopiesData.forEach(twin => {
        if (this.$refs[`twin-finder-${twin.id}`]) {
          this.$refs[`twin-finder-${twin.id}`].digitalTwin = null;
        }
        twin.parentId = parentTwin.id;
      });
    },
    handleCoordinateChange(twin) {
      this.handleParsingCoordinates(twin.coordinates.coordinates);
    }
  }
};